export default __webpack_public_path__ + "static/media/logo2.533116aa.png";